import React from 'react';
import styled from '@emotion/styled';
import { BitMap, Color } from '../../canvas/bitmap';
import { useEditorContext } from '@/src/context/EditorContext';
import { BW2x2_DATA_URL } from '../../bins';
import { ColorBitMapRender } from '../../canvas';
const pixelSize = 32;

export function BlockGroupList() {
  const {
    blockGroups,
    colorBitMaps,
    activeBitMapID,
    setActiveBitMapID,
  } = useEditorContext();
  const {
    Container,
    BlockGroupItem,
    Header,
    BlockSelectPanel,
    Grid,
    Placeholder,
  } = S;
  return (
    <Container>
      {blockGroups.entries.map(blockGroup => (
        <BlockGroupItem key={blockGroup.id}>
          <Header>
            <span>{blockGroup.name}</span>
          </Header>
          <BlockSelectPanel>
            <Grid
              style={{
                gridTemplateColumns: `repeat(${blockGroup.groupWidth},${blockGroup.blockSize}px)`,
                width: blockGroup.blockSize * blockGroup.groupWidth,
                height: blockGroup.blockSize * blockGroup.groupHeight,
              }}
            >
              {colorBitMaps.entries
                .filter(colorBitMap => colorBitMap.groupID === blockGroup.id)
                .map(colorBitMap => {
                  const BlockContainer = (props: { children?: React.ReactElement }) => (
                    <div
                      onClick={() => setActiveBitMapID(colorBitMap.id)}
                      style={{
                        width: colorBitMap.map.width,
                        height: colorBitMap.map.height,
                        overflow: 'hidden',
                        border: colorBitMap.id !== activeBitMapID ? '1px solid #fff' : '1px solid red',
                      }}
                    >
                      {props.children}
                    </div>
                  );
                  if (colorBitMap.map.eq(new BitMap<Color>(blockGroup.blockSize, blockGroup.blockSize, Color.none))) {
                    return (
                      <BlockContainer
                        key={colorBitMap.id}
                      >
                        <Placeholder />
                      </BlockContainer>

                    );
                  } else {
                    return (
                      <BlockContainer
                        key={colorBitMap.id}
                      >
                        <ColorBitMapRender
                          bitMap={colorBitMap.map}
                        />
                      </BlockContainer>
                    )
                  }
                })}
            </Grid>
          </BlockSelectPanel>
        </BlockGroupItem>
      ))}
    </Container>
  );
}
const S = {
  Container: styled.div`
    height: 100%;
  `,
  BlockGroupItem: styled.div`
    user-select: none;
    text-align: center;
    /* cursor: pointer; */
    
  `,
  Header: styled.div`
    color: #fff;
  `,
  BlockSelectPanel: styled.div`
    margin: auto;
    display: inline-block;
    cursor: pointer;
  `,
  Grid: styled.div`
    display: grid;
  `,
  Placeholder: styled.div`
    width: ${pixelSize}px;
    height: ${pixelSize}px;
    background-color: #fff;
    background-image: url(${BW2x2_DATA_URL});
    background-repeat: repeat;
    background-size: 8px 8px;
  `,
}
